/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   filters meta selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectRoot = (state: State) => state.filters
export const selectMeta = compose((state) => state.meta, selectRoot)

export const selectDirty = compose((meta) => meta.dirty, selectMeta)
